import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { driversSchema } from './schemas/driver.schema';
import { messageSchema } from './schemas/message-schema';

export function getDriverGroupsDrivers(driverGroupId: number) {
  const requestUrl = `${fleetEnvironment.driverListUrl}?includegroupId=${driverGroupId}`;
  return fromFetch(
    new Request(requestUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(
    selectData(
      messageSchema.extend({
        data: driversSchema,
      })
    )
  );
}
